<template>
  <div class="content_all2" id="ann_page">
    <div class="content_box">
      <table width="100%">
        <tr>
          <td width="50%" height="45" class="tx16">{{news.title}}</td>
          <td align="right" v-if="news.sDate">{{news.sDate.split(' ')[0]}}</td>
        </tr>
      </table>
      <div class="list_box2" v-html="(news.context)">
        {{news}}
      </div>
      <p>{{attachPicture}}</p>
      <div v-for="(picture,index) in news.pictures" :key="index">
        <div style="float:left;margin:25px;"><img style="width: 212px;" :src="picture.file_url"></div>
      </div>
      <div class="fix"></div>
      <p>{{attachFile}}</p>
      <div v-for="(file,index) in news.files" :key="index">
        <a :href="file.file_url" download>{{file.file_name}}</a>
      </div>
      <div class="fix"></div>
      <button type="submit" class="btn_m fright mt15" @click.native="back">回上一頁</button>
      <div class="fix"></div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';
export default {
  name: 'ann_page',
  data() {
    return {
      newsId: this.$route.params.newsid,
      news: [],
      locale: sessionStorage.getItem('locale'),
      attachPicture: { CH: '附加圖檔', EN: 'Attach Picture' },
      attachFile: { CH: '附加檔案', EN: 'Attach File' },
      backname: { CH: '回上一頁', EN: 'back' },
    };
  },
  created() {
    this.showPage();

    this.init();
  },
  methods: {
    init() {
      this.getNewsData();
    },
    getNewsData() {
      axios.get(API.rent_notice + `?id=${this.newsId}`)
        .then(response => {
          this.news = response.data;
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    back() {
      // this.$router.go(-1);
      window.history.go(-1)
      
    },
    showPage() {
      this.attachPicture = this.attachPicture[this.locale];
      this.attachFile = this.attachFile[this.locale];
      this.backname = this.backname[this.locale];
    }
  },

}

</script>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// AnnPage.vue?6622c5ae